<template>
    <div>
        <!-- Document Wrapper
          ============================================= -->
        <div id="wrapper" :class="{'privacy-blur': isIdle}" class="clearfix">
            <social-bar></social-bar>
            <top-header></top-header>
            <!--    <main-slider></main-slider>-->

            <router-view/>

            <main-footer></main-footer>

        </div><!-- #wrapper end -->
        <div v-if="isIdle" class="cover">
            <span>
                Screen hidden when idle<br>
                Logout in {{countDown}} sec
            </span>
        </div>
    </div>
</template>

<script>
    import SocialBar from './components/Header/SocialBar'
    import TopHeader from './components/Header/TopHeader'
    import MainFooter from './components/Footer/MainFooter'
    import { mapGetters } from 'vuex'

    export default {
        name: 'app',
        components: {
            MainFooter,
            TopHeader,
            SocialBar
        },
        computed: {
            isIdle () {
                if (this.$route.path === '/') {
                    return false
                } else {
                    return this.isAppIdle
                }
            },
            ...mapGetters(['countDown'])
        }
    }
</script>

<style>
    body:not(.no-transition) #wrapper {
        opacity: 1;
    }

    .font-secondary {
        font-family: 'Roboto', sans-serif;
    }

    .stretched #wrapper {
        width: 100%;
        margin: 0;
        box-shadow: none;
    }

    #wrapper {
        position: relative;
        float: none;
        width: 1220px;
        margin: 0 auto;
        background-color: #FFF;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }


</style>
<style scoped>
    .cover {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .cover span {
        display: block;
        margin: 20% auto 0;
        width: 500px;
        text-align: center;
        font-size: 48px;
        text-transform: uppercase;
    }

    .privacy-blur {
        filter: blur(5px);

    }

</style>
